import React, { useMemo } from 'react';
import { IconV2, TextV2, Box, ButtonV2 } from '@withjoy/joykit';
import { StyledSpinner, Wrapper } from './MessageStatus.style';
import { ReactComponent as Alert } from '@assets/icons/warning.svg';
import { useTranslation } from '@shared/core';
import { PaletteColorTokens } from '@withjoy/joykit/theme';
import { useCreditCardSetupTelemetry } from '../../../CreditCardSetup/CreditCardSetUp.telemetry';

export type InlineMessageStatus = 'warning' | 'loading';
interface ErrrorStatusProps {
  messageStatus: InlineMessageStatus;
  isInline?: boolean;
  url?: string;
}

const ICON_COLOR_BY_MESSAGE_STATUS: Record<InlineMessageStatus, keyof PaletteColorTokens> = {
  warning: 'warning5',
  loading: 'mono3',
};
export const MessageStatus: React.FC<ErrrorStatusProps> = ({ messageStatus, url, isInline = false }) => {
  const telemetry = useCreditCardSetupTelemetry();
  const { t2 } = useTranslation('sharedRegistry');
  const { checkStripeStatus, resolveStripeStatus, inReviewDuration, takingLong, inReview } = t2('creditCardSetUpDialog');
  const message = useMemo(() => {
    switch (messageStatus) {
      case 'warning':
        return takingLong;
      default:
        return inReview;
    }
  }, [messageStatus, inReview, takingLong]);
  return (
    <Wrapper
      isInline={isInline}
      flexDirection={isInline ? 'row' : 'column'}
      messageStatus={messageStatus}
    >
      {messageStatus !== 'loading' ? (
        <IconV2
          size="lg"
          color={ICON_COLOR_BY_MESSAGE_STATUS[messageStatus]}
        >
          {messageStatus === 'warning' && <Alert />}
        </IconV2>
      ) : (
        <StyledSpinner />
      )}
      <Box marginLeft={5}>
        <TextV2
          typographyVariant="body1"
          color="mono12"
          textAlign={isInline ? 'left' : 'center'}
        >
          {message}
        </TextV2>
        {messageStatus === 'loading' && (
          <TextV2
            typographyVariant="label2"
            color="mono10"
            textAlign={isInline ? 'left' : 'center'}
          >
            {inReviewDuration}
          </TextV2>
        )}
        {isInline && messageStatus !== 'loading' && (
          <ButtonV2
            onClick={() => {
              if (!url) return;

              if (messageStatus === 'warning') {
                telemetry.checkStripeStatusClicked('addCashFund.paymentMethod', url);
              } else {
                telemetry.resolveStripeIssueButtonClicked('addCashFund.paymentMethod', url || '');
              }
              return window.open(url);
            }}
            size="sm"
            color="mono14"
            typographyVariant="hed1"
            fontSize="13px"
            intent="neutral"
            variant="link"
          >
            {messageStatus === 'warning' ? checkStripeStatus : resolveStripeStatus}
          </ButtonV2>
        )}
      </Box>
    </Wrapper>
  );
};
